export enum Title {
  MR = 'Mr',
  MRS = 'Mrs',
  MS = 'Ms',
  MISS = 'Miss',
}

export const titleSelectOptions: { label: string; value: string }[] = Object.values(Title).map((title: string) => ({
  label: title,
  value: title,
}));
